// origin, defs, rowData, fields, hooks
const transformer = function (origin, defs, rowData, fields, hooks) {
  return {
    render: 'statistics',
    value: origin,
    origin,
    defs,
    fields,
    rowData,
    hooks,
  }
}

export default transformer
